import { GridColumnHeader } from '../components/Grid/types';
import { Attribute, DataSource } from '../types/entities.types';

const gridHeaders: GridColumnHeader[] = [
  {
    name: 'businessMetadata.asset_name',
    label: 'Metric Name',
    width: '30%',
    filter: {
      type: 'text',
      remoteSearchFields: ['asset_name'],
    },
    sortable: true,
    remoteSortField: 'asset_name',
  },
  {
    name: 'businessMetadata.descriptiveMetadata.description',
    label: 'Description',
    width: '70%',
  },
  { name: 'lineage', label: 'Lineage', width: '10%' },
];

const attributesMap: Attribute[] = [
  {
    name: 'businessMetadata.asset_id',
    label: 'Metric Id',
    showInColumn: 0,
    description: 'Metric id',
  },
  {
    name: 'businessMetadata.asset_name',
    label: 'Metric Name',
    showInColumn: 0,
    description: 'Metric name',
  },
  {
    name: 'businessMetadata.descriptiveMetadata.description',
    label: 'Description',
    showInColumn: 2,
    description: 'Metric description',
  },
  {
    name: 'technicalMetadata.asset_type',
    label: 'Metric Type',
    showInColumn: 0,
    description: 'Metric type',
  },
  {
    name: 'technicalMetadata.created_time',
    label: 'Created Time',
    showInColumn: 0,
    description: 'Created time',
    type: 'date',
  },
  {
    name: 'businessMetadata.administrativeMetadata.technical_data_steward',
    label: 'Technical Data Steward',
    showInColumn: 2,
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.background_context',
    label: 'Background Context',
    showInColumn: 1,
    description: 'Background Context',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.business_formula',
    label: 'Business Formula',
    showInColumn: 1,
    description: 'Business Formula',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.query',
    label: 'Query',
    showInColumn: 1,
    description: 'query',
    type: 'html',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.metric_classification',
    label: 'Metric Classification',
    showInColumn: 1,
    description: 'metric_classification',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.source_columns',
    label: 'Source Columns',
    showInColumn: 1,
    description: 'source_columns',
    type: 'sourceColumns',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.source_tables',
    label: 'Source Tables',
    showInColumn: 1,
    description: 'source tables',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.data_domains',
    label: 'Data Domains',
    showInColumn: 1,
    description: 'Data Domains',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.schema_names',
    label: 'Schema Names',
    showInColumn: 1,
    description: 'Schema Names',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.business_data_stewards',
    label: 'Business Data Stewards',
    showInColumn: 1,
    description: 'Business Data Stewards',
    type: 'array',
  },
  {
    name: 'sourceSpecificMetadata.MetricCatalog.business_segments',
    label: 'Business Segments',
    showInColumn: 1,
    description: 'Business Segments',
    type: 'array',
  },
];

const customQueryForListPage = `
  MetricCatalog {
    background_context
    business_formula
    metric_classification
    query
    source_columns
    source_tables
    data_domains
    schema_names
    business_data_stewards
    business_segments
  }
`;

const customQueryForDetailsPage = `
  MetricCatalog {
    background_context
    business_formula
    metric_classification
    query
    source_columns
    source_tables
    data_domains
    schema_names
    business_data_stewards
    business_segments
  }
`;

export const MetricCatalogConfig: DataSource = {
  id: '12',
  name: 'MetricCatalog',
  showColumns: false,
  showPartitionColumns: false,
  showLineage: true,
  showLineageTable: false,
  showLineagePipeline: false,
  showLineageQuery: false,
  showLineageCloned: false,
  showLineageCW: false,
  showLineageColumn: false,
  showLineageDashboard: true,
  showDashboards: true,
  gridHeaders,
  attributesMap,
  customQueryForListPage,
  customQueryForDetailsPage,
  glossary: false,
  label: 'Metrics',
};
